import { isEmpty } from 'lodash';

const getCustomerGroupResponse = (data) => {
    if (isEmpty(data)) return [];

    const mappingData = data?.map((item) => {
        return {
            ...item,
            id: item?.name,
        };
    });

    return mappingData;
};

export default getCustomerGroupResponse;
